import * as React from 'react';
import { Skeleton } from '@mui/material';
import Flex from 'ui/Flex/Flex';

const AlertLoading = () => (
    <Flex
        align="center"
        sx={{ p: '1rem', borderBottom: '1px solid #f8f8f8', w: '100%' }}
    >
        <Skeleton variant="circular" height={40} width={40} />
        <Skeleton variant="text" height={40} width={200} sx={{ ml: '1rem' }} />
    </Flex>
);

export default AlertLoading;
